import classname from 'classnames'
import * as React from 'react'

import { ChartBoxover } from '../../../../app/shared/components/ChartBoxover'
import { Button, ButtonComponentProps, Tag, Tooltip, TooltipTrigger, useTooltipState } from '../../../components'
import { HoldingOptionType, HoldingOptionTypeLabelMap, TopInvestmentType } from '../constants'

interface Props extends Pick<TopInvestmentType, 'ticker' | 'name' | 'boxoverData'>, ButtonComponentProps {
  className?: string
  putCall?: HoldingOptionType
}

export function TickerButton({ ticker, name, putCall, boxoverData, className, ...props }: Props) {
  const tooltipState = useTooltipState({ placement: 'bottom-start' })
  const button = (
    <Button
      {...(boxoverData ? { as: 'a', href: `/quote.ashx?t=${ticker}` } : { disabled: true })}
      theme={boxoverData ? 'link' : 'transparent'}
      align="left"
      size="none"
      className={classname('inline-flex border-none', className)}
      {...props}
    >
      <div className="inline-flex space-x-1">
        <span>{ticker ?? '-'}</span>
        {putCall && [HoldingOptionType.Put, HoldingOptionType.Call].includes(putCall) ? (
          <Tag size="small">{HoldingOptionTypeLabelMap[putCall]}</Tag>
        ) : null}
      </div>
    </Button>
  )

  if (!boxoverData) {
    return (
      <>
        <TooltipTrigger tabIndex={-1} className="inline" state={tooltipState}>
          {button}
        </TooltipTrigger>
        <Tooltip state={tooltipState} className="px-2 text-xs">
          {name ?? ticker ?? '-'}
        </Tooltip>
      </>
    )
  }

  return (
    <ChartBoxover entry={boxoverData} offsetY={20}>
      {button}
    </ChartBoxover>
  )
}
